/*
 * Collection grid-density switcher.
 * Applies a data-cols attribute to #product-grid so CSS can override the desktop
 * column count. Persists the choice in localStorage and re-applies it after
 * facet filtering / load-more replaces or mutates the grid.
 */
(function () {
  var STORAGE_KEY = 'tb:collection-cols';

  function getStored() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function setStored(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* ignore */
    }
  }

  function applyCols(cols) {
    var grid = document.getElementById('product-grid');
    if (grid) grid.setAttribute('data-cols', cols);

    document.querySelectorAll('[data-grid-switch] .grid-switch__btn').forEach(function (btn) {
      var isActive = btn.dataset.cols === String(cols);
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function currentCols() {
    var stored = getStored();
    if (stored) return stored;
    var active = document.querySelector('[data-grid-switch] .grid-switch__btn.is-active');
    return active ? active.dataset.cols : null;
  }

  function bind() {
    var groups = document.querySelectorAll('[data-grid-switch]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      if (group.dataset.bound) return;
      group.dataset.bound = 'true';
      group.addEventListener('click', function (event) {
        var btn = event.target.closest('.grid-switch__btn');
        if (!btn) return;
        var cols = btn.dataset.cols;
        setStored(cols);
        applyCols(cols);
      });
    });

    var cols = currentCols();
    if (cols) applyCols(cols);
  }

  function init() {
    bind();

    // Re-apply the stored density whenever the grid container is replaced
    // (Dawn facets / sort) or appended to (load more).
    var container = document.getElementById('ProductGridContainer');
    if (container && !container.dataset.gridSwitchObserved) {
      container.dataset.gridSwitchObserved = 'true';
      var observer = new MutationObserver(function () {
        var cols = currentCols();
        if (cols) applyCols(cols);
      });
      observer.observe(container, { childList: true, subtree: true });
    }

    document.addEventListener('collection:updated', function () {
      var cols = currentCols();
      if (cols) applyCols(cols);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
